import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { EmptyStateExampleCompanyProfilesCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/empty-state-example-company-profiles-cta';
import { EmptyInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-info-box';
import styled from 'styled-components';

interface Props {
  message: string;
}

export function EmptyStateFundNoData(props: Props) {
  return (
    <EmptyInfoBox title="No data available" topColor={BouColor.IMPACT_NEGATIVE_PURPLE}>
      <>
        <Text>{props.message}</Text>
        <EmptyStateExampleCompanyProfilesCTA />
      </>
    </EmptyInfoBox>
  );
}

const Text = styled.div`
  margin-bottom: 1.5em;
`;
